import { render } from "./A4Form.vue?vue&type=template&id=413a6f68&scoped=true"
import script from "./A4Form.vue?vue&type=script&lang=js"
export * from "./A4Form.vue?vue&type=script&lang=js"

import "./A4Form.vue?vue&type=style&index=0&id=413a6f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413a6f68"]])

export default __exports__